// extracted by mini-css-extract-plugin
module.exports = {"owner":"About_owner__3EY8q","box":"About_box__2W7AQ","developer":"About_developer__20HxI"};